var map = {
	"./example.svg": 57893,
	"./eye.svg": 28431,
	"./form.svg": 82962,
	"./home.svg": 26152,
	"./login-mall.svg": 52244,
	"./marker.svg": 25769,
	"./order-return-reason.svg": 82578,
	"./order-return.svg": 31543,
	"./order-setting.svg": 20696,
	"./order.svg": 75752,
	"./password.svg": 64117,
	"./product-add.svg": 81304,
	"./product-attr.svg": 11170,
	"./product-brand.svg": 59963,
	"./product-cate.svg": 74342,
	"./product-comment.svg": 91114,
	"./product-list.svg": 59972,
	"./product-recycle.svg": 52958,
	"./product.svg": 25391,
	"./sms-ad.svg": 79803,
	"./sms-coupon.svg": 16356,
	"./sms-flash.svg": 42287,
	"./sms-hot.svg": 17657,
	"./sms-new.svg": 58289,
	"./sms-subject.svg": 86867,
	"./sms.svg": 49117,
	"./table.svg": 85695,
	"./total-today.svg": 61635,
	"./total-week.svg": 38644,
	"./total-yesterday.svg": 17840,
	"./tree.svg": 79162,
	"./user.svg": 47798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87886;